import {Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {ServiceOrderInvoiceFormComponent} from "../service-order-invoice-form/service-order-invoice-form.component";

@Component({
    selector: 'app-service-order-invoice-update',
    templateUrl: './service-order-invoice-update.component.html',
    styleUrl: './service-order-invoice-update.component.scss'
})
export class ServiceOrderInvoiceUpdateComponent {

    @ViewChild('data') data!: ServiceOrderInvoiceFormComponent;

    @Input() public invoiceNumber = '';

    @Output() public invoiceNumberForm = new EventEmitter();

    public editMode = false;

    public changeEditMode(): void {
        this.editMode = !this.editMode;
    }

    public saveInvoiceNumber(): void {
        this.invoiceNumberForm.emit(this.data.invoiceForm.getRawValue());
        this.editMode = !this.editMode;
    }
}
